export * from './email-directive';
export * from './phone-directive';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/validators/index.ts